module.exports = __webpack_public_path__ + "img/big3-4.4d76833d.jpg";